import * as Sentry from "@sentry/react";

import { IS_PRODUCTION, environment } from "@config";
import { User } from "@ctypes";

const init = async () => {
  if (!IS_PRODUCTION) return;

  Sentry.init({
    dsn: environment.sentry.dsn,
  });
};

const identify = ({ id, email }: User) => {
  if (!IS_PRODUCTION) return;

  if (id && email) {
    Sentry.setUser({
      id,
      email,
    });
  }
};

const capture = (error: any) => {
  if (!IS_PRODUCTION) return;

  Sentry.captureException(error);
};

export const ErrorService = { init, identify, capture };
